import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Table, TableCell, TableHeader, Colors, Modal } from 'advenio-components'
import styled from 'styled-components'
import { push } from 'react-router-redux'
import { slugify } from '../../utils/Utils'
import OverviewActions from '../../Data/Redux/OverviewRedux'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`
const CountryContainer = styled.div`
  width: 90%;
  margin-top: 50px;
  flex-direction: column;
`
const Country = styled.span`
  font-weight: bold;
  font-size: 20px;
`
const CountryTitle = styled.div`
  height: 30px;
  margin-bottom: 10px;
`
const Info = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content:space-between;
  align-items: center;
  margin-bottom: 20px;
`
const Card = styled.div`
  width: ${props => props.large ? '400px' : '180px'};
  height: 150px;
  background: #FFFFFF;
  display: flex;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: space-between;
  margin-right: 5px;
  padding: 16px;
  flex-direction: column;
  border: 1px solid #C4CDD5;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
  border-radius: 6px;
  &:last-child {
    margin-right: 0;
  }
  @media (max-width: 1024px) {
    width: ${props => props.large ? '300px' : '130px'};
  }
`
const CardTitle = styled.span`
  font-size: 14px;
  color: #919EAB;
  font-weight: bold;
  @media (max-width: 1024px) {
    font-size: 12px;
  }
`
const CardData = styled.span`
  font-size: 48px;
  font-weight: bold;
  color: #3E4757;
  @media (max-width: 1024px) {
    font-size: 36px;
  }
`
const PercentageContainer = styled.div`
  flex-direction: row;
  font-size: 12px;
  height: 15px;
`
const CellContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:#FFFFFF;
  height: 100%;
  ${({ blue }) => blue && `
    color: ${Colors.blue500};
    cursor: pointer;
  `}
`
const TableContainer = styled.div`
  width: 100%;
  margin-bottom: 15px;
  border-radius: 6px;
  border: 1px solid #C4CDD5;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
`
const PercentageNum = styled.span`
  margin-right: ${({ marginRight }) => `${marginRight}px` || '2px'};
  color: ${Colors.blue500};
  font-weight: bold;
`
const PercentageNumContainer = styled.span`
  margin-left: 5px;
`

class Dashboard extends Component {
  state = {
    info: [],
  }

  componentWillMount() {
    this.props.getOverview()
  }

  componentWillReceiveProps(nextProps) {
    const { overview } = nextProps
    const newData = []
    if (overview) {
      Object.keys(overview).map((region) => {
        const regionData = { name: region }
        if (overview[region].centers) {
          Object.keys(overview[region]).map((data) => {
            regionData[data] = (overview[region][data])
            return data
          })
          return newData.push(regionData)
        }
      })
      this.setState({ info: newData })
    }
  }

  getCheckedOutPercentage = (checkin, checkout, table) => {
    const percentage = this.calculatePercentage(checkout, checkin)

    if (table) {
      return (
        <div>
          <span>{checkout}</span>
          <PercentageNumContainer>
            (<PercentageNum>{percentage}%</PercentageNum> de los ingresados hoy)
          </PercentageNumContainer>
        </div>
      )
    }

    return (
      <div>
        <PercentageNum marginRight={5}>{percentage}%</PercentageNum>
        <span style={{ color: Colors.gray500 }}>de los ingresados</span>
      </div>
    )
  }

  getActivePercentage = (active, total, table) => {
    const percentage = this.calculatePercentage(active, total)

    if (table) {
      return (
        <div>
          <span>{active} de {total}</span>
          <PercentageNumContainer>
            (<PercentageNum>{percentage}%</PercentageNum> lleno)
          </PercentageNumContainer>
        </div>
      )
    }

    return (
      <div>
        <PercentageNum marginRight={5}>{percentage}%</PercentageNum>
        <span style={{ color: Colors.gray500 }}>lleno</span>
      </div>
    )
  }

  getData = () => (
    this.state.info.map(({ totals, ...currentValue }) => (
      <CountryContainer key={slugify(currentValue.name)}>
        <CountryTitle>
          <Country>{currentValue.name}</Country>
        </CountryTitle>
        <Info>
          <Card>
            <CardTitle>ACTIVOS</CardTitle>
            <CardData>{totals && totals.active_count}</CardData>
            <PercentageContainer>
              {totals && this.getActivePercentage(
                totals.active_count,
                totals.enrolled_students_count,
                false,
              )}
            </PercentageContainer>
          </Card>
          <Card>
            <CardTitle>CHECKED OUT</CardTitle>
            <CardData>{totals && totals.checked_out_count}</CardData>
            <PercentageContainer>
              {totals && this.getCheckedOutPercentage(
                totals.checkins_today_count,
                totals.checked_out_count,
                false,
              )}
            </PercentageContainer>
          </Card>
          <Card>
            <CardTitle>SALA DE SINTOMAS</CardTitle>
            <CardData>{totals && totals.sick_room_count}</CardData>
            <PercentageContainer />
          </Card>
          <Card>
            <CardTitle>CENTRO VIRTUAL</CardTitle>
            <CardData>{totals && totals.virtual_center_count}</CardData>
            <PercentageContainer />
          </Card>
          <Card large>
            <CardTitle>COBRANZA PENDIENTE</CardTitle>
            <CardData>{totals && totals.outstanding_bills_formatted}</CardData>
            <PercentageContainer />
          </Card>
        </Info>
        <TableContainer>
          <Table
            data={currentValue.centers}
            roundedCorners
            columns={[
              {
                id: '1',
                Header: () => <TableHeader title="Centros" center blue />,
                accessor: ({ name, abbreviation, id }) => ({ name, abbreviation, id }),
                Cell: ({ value: { name, abbreviation, id } }) => (
                  <CellContainer blue onClick={() => this.goTo(id, abbreviation)}>
                    {name} ({abbreviation})
                  </CellContainer>
                ),
              },
              {
                id: '2',
                Header: () => <TableHeader title="Activos" center blue />,
                accessor: ({ active_count, enrolled_students_count }) =>
                  ({ active_count, enrolled_students_count }),
                Cell: ({ value: { active_count, enrolled_students_count } }) => (
                  <TableCell center>
                    {this.getActivePercentage(active_count, enrolled_students_count, true)}
                  </TableCell>
                ),
              },
              {
                id: '3',
                Header: () => <TableHeader title="Checked Out" center blue />,
                accessor: ({ checked_out_count, checkins_today_count }) =>
                  ({ checked_out_count, checkins_today_count }),
                Cell: ({ value: { checked_out_count, checkins_today_count } }) => (
                  <TableCell center>
                    {this.getCheckedOutPercentage(checkins_today_count, checked_out_count, true)}
                  </TableCell>
                ),
              },
              {
                id: '4',
                Header: () => <TableHeader title="Síntomas" center blue />,
                accessor: ({ sick_room_count }) => ({ sick_room_count }),
                Cell: ({ value: { sick_room_count } }) =>
                  <TableCell center>{sick_room_count}</TableCell>,
              },
              {
                id: '5',
                Header: () => <TableHeader title="Centro Virtual" center blue />,
                accessor: ({ virtual_center_count }) => ({ virtual_center_count }),
                Cell: ({ value: { virtual_center_count } }) =>
                  <TableCell center>{virtual_center_count}</TableCell>,
              },
              {
                id: '6',
                Header: () => <TableHeader title="Cobranza Pendiente" center blue />,
                accessor: ({ outstanding_bills_formatted }) => ({ outstanding_bills_formatted }),
                Cell: ({ value: { outstanding_bills_formatted } }) =>
                  <TableCell center>{outstanding_bills_formatted}</TableCell>,
              },
            ]}
          />
        </TableContainer>
      </CountryContainer>
    ))
  )

  /**
   * Returns a percentage with up to 2 decimal places.
   * If the percentage is a whole number (e.g. 2%), it will be returned with no decimal places.
   * If the percentage originally only has 1 decimal place (e.g. 0.2%),
   * it will be returned with just 1 decimal place.
   * In all other scenarios (e.g. 0.2562%), it will be rounded and returned with 2 decimal places.
   */
  calculatePercentage = (current, originalTotal) => {
    const total = originalTotal || 1

    const percentage = (current / total) * 100

    return Math.round(percentage * 100) / 100 || 0
  }

  goTo = (id, name) => {
    this.props.setCenter(id)
    this.props.setCenterName(name)
    this.props.goTo(`centers/${id}/overview`)
  }

  render() {
    return (
      <Container>
         {this.state.info.length === 0 && <Modal isOpened loading />}
        {this.state.info.length > 0 && this.getData()}
      </Container>
    )
  }
}

Dashboard.propTypes = {
  /** The reports overview data */
  overview: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  /** Store the ID of the Advenio center currently being viewed in Redux */
  setCenter: PropTypes.func.isRequired,
  /** Store the name of the Advenio center currently being viewed in Redux */
  setCenterName: PropTypes.func.isRequired,
  /** Fetch the reports overview data from the API */
  getOverview: PropTypes.func.isRequired,
  /** Navigate to the given URI */
  goTo: PropTypes.func.isRequired,
}

const mapStateToProps = ({ overview }) => ({
  overview: overview.get.results,
})

const mapDispatchToProps = dispatch => ({
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
  setCenterName: name => dispatch(CentersInfoActions.setCenterName(name)),
  getOverview: () => dispatch(OverviewActions.getRequest()),
  goTo: link => dispatch(push(link)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/index.jsx